import { FC } from "react";
import { twMerge } from "tailwind-merge";

type IProps = {
  hasBackground?: boolean;
};

const GeneralLoader: FC<IProps> = ({ hasBackground = false }) => {
  return (
    <div
      className={twMerge(
        "fixed inset-0 flex justify-center items-center !z-[99]",
        hasBackground && "bg-black/50"
      )}
    >
      <span className="general-loader" />
    </div>
  );
};

export default GeneralLoader;
